import { graphql } from "gatsby";
import React, { Children, ReactNode } from "react";
import { VariantCardDataFragment } from "../../graphql-types";
import Image from "./GatsbyImage";
import InternalLink from "./InternalLink";
import { DoubleCarousel } from "./Carousel";
interface VariantGridProps {
  title?: string | null;
  children: ReactNode;
}

const VariantGrid: React.FC<VariantGridProps> = ({ children, title }) => (
  <div className="p-8 mt-16 md:p-16 bg-gray-100">
    {title && <h2 className="text-center title">{title}</h2>}
    <ul className="grid grid-cols-1 md:grid-cols-3 gap-4">{children}</ul>
  </div>
);

export const VariantCarousel: React.FC<VariantGridProps> = ({
  children,
  title,
}) => {
  if (!children || Children.toArray(children).length == 0) {
    return null;
  }
  return (
    <div className="relative py-5">
      {title && <h2 className="text-center title py-4 font-bold">{title}</h2>}
      <DoubleCarousel name={title?.replace(" ", "-") || "VariantCarousel"}>
        {children}
      </DoubleCarousel>
    </div>
  );
};

export default VariantGrid;

export interface VariantCardProps {
  variant: VariantCardDataFragment;
  className?: string;
  id?: string;
}

export const VariantCarouselCard: React.FC<VariantCardProps> = ({
  variant,
  className,
  id,
}) => (
  <li className={className} id={id}>
    <InternalLink
      href={variant.path}
      className="flex flex-col p-8 bg-white rounded-lg shadow-sm group hover:no-underline hover:shadow-md"
    >
      <Image
        image={variant.packshot.gatsbyImageData}
        alt={variant.packshot.description || ""}
      />
      <span className="block mt-4 text-base font-bold group-hover:underline">
        {variant.name}
      </span>
    </InternalLink>
  </li>
);

export const VariantCard: React.FC<VariantCardProps> = ({ variant }) => (
  <li>
    <InternalLink
      href={variant.path}
      className="flex flex-col p-8 bg-white rounded-lg shadow-sm group hover:no-underline hover:shadow-md"
    >
      <Image
        image={variant.packshot.gatsbyImageData}
        alt={variant.packshot.description || ""}
      />
      <span className="block mt-4 text-xl font-bold group-hover:underline">
        {variant.name}
      </span>
    </InternalLink>
  </li>
);

export const fragments = graphql`
  fragment VariantCardData on Variant {
    path
    name
    packshot {
      description
      gatsbyImageData
    }
  }
`;
